import { Select } from '@mantine/core';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import { Project, projectConfigs, PROJECTS } from '@/shared/config/projects';
import { projectPath, useCurrentProject } from '@/shared/projects/project-path';
import { useGlobalStore } from '@/shared/stores/global.store';

export function ProjectSwitcher() {
  const project = useCurrentProject();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const isDirty = useGlobalStore((state) => state.navigation.isDirty);
  const setDirty = useGlobalStore((state) => state.navigation.setDirty);
  const setActiveProject = useGlobalStore((state) => state.setActiveProject);

  const switchProject = async (value: string | null) => {
    if (!value || value === project) return;
    const nextProject = value as Project;

    if (
      isDirty &&
      !window.confirm('Изменения не сохранены. Переключить проект?')
    ) {
      return;
    }

    await queryClient.cancelQueries({
      predicate: (query) => query.queryKey[0] === project,
    });
    setDirty(false);
    setActiveProject(nextProject);
    navigate(projectPath(nextProject, '/books'));
  };

  return (
    <Select
      aria-label="Проект"
      value={project}
      onChange={(value) => void switchProject(value)}
      data={PROJECTS.map((item) => ({
        value: item,
        label: projectConfigs[item].label,
      }))}
      allowDeselect={false}
    />
  );
}
